import { Extension } from '@tiptap/core'
import { Plugin } from '@tiptap/pm/state'
import {
  findInsufficientInformationMatches,
  INSUFFICIENT_INFORMATION_MARK,
} from './insufficient-information-mark'

/**
 * Applies insufficientInformation mark after any transaction that leaves the token
 * text without the mark.
 */
export const InsufficientInformationPlugin = Extension.create({
  name: 'insufficientInformationPlugin',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        appendTransaction(_transactions, _oldState, newState) {
          const { schema, tr: transaction, doc } = newState
          const markType = schema.marks[INSUFFICIENT_INFORMATION_MARK]
          if (!markType) {
            return null
          }

          let modified = false

          doc.descendants((node, pos) => {
            if (!node.isText || !node.text) {
              return
            }

            for (const match of findInsufficientInformationMatches(node.text)) {
              const from = pos + match.index
              const to = from + match.length
              if (!newState.doc.rangeHasMark(from, to, markType)) {
                transaction.addMark(from, to, markType.create())
                modified = true
              }
            }
          })

          return modified ? transaction : null
        },
      }),
    ]
  },
})
